import api from "../axios";
import Api from "../Api";

export async function LotsByAll(search,id,setID) {
  // alert('sss')
  const response = await api
    .get(`${Api.request.URL}/lot?auction_id=${id===undefined?  "116":id}&set_id=${setID===undefined?  "89":setID}&search=${search===undefined?  "":search}&category=&medium=&start=0&limit=20`)
    .then((res) => {
    console.log("data data: ", res.data);
      return res.data;
    })
    .catch((error) => {
     console.log("data errorr: ",error.response.data.sucess);
       return error.response.data.sucess;
    });
  return response;
}







export async function removeAbsentee(data) {
  const response = await api
    .post(`${Api.request.URL}/lot/remove-absentee-bid`, data)
    .then((res) => {
      return res.data;
    })
    .catch((error) => {
      return error.response.data;
    });
  return response;
}



// export async function removeAbsentee(id = "") {
//   try {
    
//     const res = await api.post(`${Api.request.URL}/lot/remove-absentee-bid`, {"absenteeId":id});
//     return res.data.msg;
//   } catch (error) {
//     console.error("AuctionSetupCreate error:", error);
//     return error?.response?.data?.msg || "Something went wrong.";
//   }
// }




export async function getLogs(search = "", auctionID = "") {
  try {
    const res = await api.get(
      `${Api.request.URL}/lot/logs?auction_id=${auctionID}&search=${search}`
    );
    return res.data;
  } catch (error) {
    // Optional: log full error if needed
    console.error("getLogs error:", error);

    // Return safe error response
    return error?.response?.data?.errors || [];
  }
}


// export async function getLogs(search,auctionID) {
//   const response = await api
//     .get(`${Api.request.URL}/lot/logs?auction_id=${auctionID === undefined ? "": auctionID}&search=${search === undefined ? "":search}`)
//     .then((res) => {
//       return res.data;
//     })
//     .catch((error) => {
//       return error.response.data.errors;
//     });
//   return response;
// }



export async function findlot(search,auctionID) {
  const response = await api
    .get(`${Api.request.URL}/lot/find-lot?auction_id=${auctionID === undefined ? "":auctionID}&search=${search=== undefined ? "":search}`)
    .then((res) => {

      return res.data;
    })
    .catch((error) => {
      return error.response.data.errors;
    });
  return response;
}




export async function findById(lotnumber,auctionID,setId) {
  const response = await api
    .get(`${Api.request.URL}/lot/${auctionID}/${setId}/${lotnumber}`)
    .then((res) => {

      return res.data;
    })
    .catch((error) => {
      return error.response.data.errors;
    });
  return response;
}



export async function EditSetupLots(data) {
    const response = await api
      .put(`${Api.request.URL}/lot`,data)
      .then((res) => {
        // console.log("data data: ", res.data);
        return res.data.msg;
      })
      .catch((error) => {
        return error.response.data.errors;
      });
    return response;
  }
  

  export async function getFindById(auctionId,setId,id) {
    const response = await api
      .get(`${Api.request.URL}/lot/${auctionId}/${setId}/${id}`)
      .then((res) => {
        //   let result = {};
        // res.data.data.map((val)=>{
        //     return (result = val)
        // })
        // console.log("data data: ", res.data);
        return res.data;
      })
      .catch((error) => {
        return error.response.data.errors;
      });
    return response;
  }
